import { derived, writable } from "svelte/store";
import { fromHex } from "../Utilities/hex";
import { handlePolicy, localKeyHandle } from "../Utilities/keys";
import { wallet, balance } from './wallet';
// The currently selected handle, initially populated from local storage
export const selectedHandle = writable("", (set) => {
    set(localStorage.getItem(localKeyHandle));
});
// If the handle is updated, write it to local storage
selectedHandle.subscribe(h => {
    if (!!h) {
        localStorage.setItem(localKeyHandle, h);
    }
});
// the wallet is disconnected, clear the handle selection
wallet.subscribe(w => {
    if (w.state == 'disconnected') {
        localStorage.removeItem(localKeyHandle);
    }
});
// Aggregate a list of handles from the wallet balance
export const handles = derived(balance, b => {
    if (b === null || b === void 0 ? void 0 : b.assets[handlePolicy]) {
        return Object.keys(b.assets[handlePolicy]).map(fromHex);
    }
    return [];
});
